import { Avatar, Rating } from "@/_ui";
import { formatDateTime } from "@/lib";
import { useTranslation } from "@/lib";
import { Tablature, TablatureComment } from "@/types/tablatures";



interface Props {
    tab: Tablature;
}



export const TabComment = ({ comment }: { comment: TablatureComment }) => {

    if (!comment) {
        console.error("TabComment: comment is undefined", comment);
        return null;
    }

    return (
        <article className="border border-[var(--color-gray-200)] rounded-lg p-4 hover:bg-[var(--color-gray-50)] transition-colors">
            <div className="flex gap-4">
                <div className="flex-shrink-0">
                    <Avatar
                        src={comment.user.imageUrl}
                        size="lg"
                        alt={`Avatar de ${comment.user.displayName}`}
                    />
                </div>

                <div className="flex-1 min-w-0">
                    <header className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 mb-3">
                        <div>
                            <h4 className="font-semibold text-[var(--color-gray-900)]">
                                {comment.user.displayName}
                            </h4>
                            <time className="text-sm text-[var(--color-gray-500)]">
                                {formatDateTime(comment.createdAt)}
                            </time>
                        </div>

                        {comment.rating > 0 && (
                            <div title={`Évaluation: ${comment.rating}/5`}>
                                <Rating
                                    value={comment.rating}
                                    disabled={true}
                                    cancel={false}
                                    onChange={() => { }}
                                // size="xs"
                                />
                            </div>
                        )}
                    </header>

                    <div
                        className="prose prose-sm max-w-none text-[var(--color-gray-800)]"
                        dangerouslySetInnerHTML={{ __html: comment.message }}
                    />
                </div>
            </div>
        </article>
    );
}


export const TablatureHelp = () => {
    const { t } = useTranslation()

    const helpSections = [
        {
            title: t('tablatures.help.basics'),
            items: [
                { symbol: 'S', description: t('tablatures.notation.short_blow') },
                { symbol: 'A', description: t('tablatures.notation.short_draw') },
                { symbol: '1', description: t('tablatures.notation.note') },
                { symbol: '1..', description: t('tablatures.notation.long_note') }
            ]
        },
        {
            title: t('tablatures.help.alterations'),
            items: [
                { symbol: "1'", description: t('tablatures.notation.alteration_12') },
                { symbol: "1''", description: t('tablatures.notation.alteration_1') },
                { symbol: "1'''", description: t('tablatures.notation.alteration_112') },
                { symbol: '1o', description: t('tablatures.notation.overblow') }
            ]
        },
        {
            title: t('tablatures.notation.format'),
            items: [
                { symbol: '|', description: t('tablatures.notation.divider') },
                { symbol: ' ', description: t('tablatures.notation.space') },
                { symbol: '|:', description: t('tablatures.notation.repeat_start') },
                { symbol: ':|', description: t('tablatures.notation.repeat_end') },
                { symbol: '/', description: t('tablatures.notation.break') },
                { symbol: '(', description: t('tablatures.notation.group_start') },
                { symbol: ')', description: t('tablatures.notation.group_end') }
            ]
        }
    ];

    return (
        <div className="space-y-6">
            {helpSections.map((section, sectionIndex) => (
                <section key={sectionIndex}>
                    <h3 className="text-lg font-semibold text-[var(--color-gray-900)] mb-4 flex items-center gap-2">
                        <i className="fa-solid fa-circle-question" />
                        {section.title}
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                        {section.items.map((item, itemIndex) => (
                            <div key={itemIndex} className="flex items-center gap-3">
                                <span className="inline-flex items-center justify-center w-10 h-8 bg-white text-grey-700 text-sm font-mono font-bold rounded border-1 border-grey-700 flex-shrink-0 text-center">
                                    {item.symbol === ' ' ? '\u00A0' : item.symbol}
                                </span>
                                <span className="text-[var(--color-gray-700)] text-sm">
                                    {item.description}
                                </span>
                            </div>
                        ))}
                    </div>
                </section>
            ))}
        </div>
    );
}

